import * as React from 'react';
import { Typography } from '@revfluence/fresh';

const { Text } = Typography;

export const NAText = () => (
  <Text type="secondary" weight="semibold">N/A</Text>
);
